import React, { useContext, useEffect, useState } from 'react';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import cls from './UploadImage.module.css';
import { ImageCard } from '../../../UI/ImageCard/ImageCard';
import { MeasurementsDragZone } from '../../../UI/MeasurementsDragZone/MeasurementsDragZone';
import { useUploadImage } from './useUploadImage';
import { MeasuremntsContext } from '../../../Context/MeasuremntsContext';
import { makeDecodeURL } from '../../../../../shared/helpers/makeDecodeURL';

export const UploadImage = () => {
    const [isImageOver, setIsImageOver] = useState(false);
    const { imageList, setImageList } = useContext(MeasuremntsContext);
    const { ids, entities } = useSelector((state) => state.measurementsReducer.attachments);
    const { onImageChange } = useUploadImage();

    useEffect(() => {
        const fetchData = async () => {
            const newData = await Promise.all(
                ids.map(async (id) => {
                    const file = entities[id];
                    try {
                        const response = await fetch(file.preview_url);
                        const blob = await response.blob();
                        const filename = makeDecodeURL(
                            file.url.substring(file.url.lastIndexOf('/') + 1)
                        );
                        const newFile = new File([blob], filename, { type: blob.type });

                        return {
                            file: newFile,
                            previewUrl: file.url,
                            type: 'attachments',
                            id: file.id,
                        };
                    } catch (error) {
                        swal({
                            text: i18next.t('UploadImage.return.swal.errorMessage'),
                            cancel: false,
                            confirm: true,
                            button: {
                                text: i18next.t('UploadImage.return.swal.okButton'),
                                value: true,
                                visible: true,
                                className: 'btn btn-secondary',
                            },
                        });
                    }
                })
            );

            const validData = newData.filter((item) => item !== null);

            setImageList(validData);
        };

        fetchData();
    }, [setImageList, entities]);
    const handleDragOver = (e) => {
        e.preventDefault();
        setIsImageOver(true);
    };

    const handleDragEnter = (e) => {
        e.preventDefault();
        setIsImageOver(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        const { relatedTarget } = e;

        if (!e.currentTarget.contains(relatedTarget)) {
            setIsImageOver(false);
        }
    };

    const handleFiles = (files) => {
        return files.map((file) => ({
            file,
            previewUrl: URL.createObjectURL(file),
        }));
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsImageOver(false);
        const uploadFiles = Array.from(e.dataTransfer.files);
        const files = handleFiles(uploadFiles);
        onImageChange(files);
    };

    const handleImageClick = (event) => {
        if (imageList.length > 0) {
            if (event.target.classList.contains(cls.miniZone)) {
                document.getElementById('fileInput').click();
            }
        } else {
            document.getElementById('fileInput').click();
        }
    };

    const handleInputChange = (e) => {
        e.stopPropagation();
        const uploadFiles = Array.from(e.target.files);
        const files = handleFiles(uploadFiles);
        onImageChange(files);
        e.target.value = '';
    };
    return (
        <div className={cls.Container}>
            <h3 className={cls.TitleUploadImg}>{i18next.t('UploadImage.return.TitleUploadImg')}</h3>
            <div
                onDragEnter={handleDragEnter}
                className={classNames(cls.ImageUploadArea, {
                    [cls.ImageUploadAreaEmpty]: imageList.length <= 0,
                    [cls.ImageUploadAreaNotEmpty]: imageList.length > 0,
                })}
                onClick={handleImageClick}
            >
                <input
                    id="fileInput"
                    type="file"
                    accept="image/*"
                    onChange={handleInputChange}
                    style={{ display: 'none' }}
                    multiple
                />
                {imageList.length ? (
                    <>
                        <div className={classNames(cls.UploadBlock, cls.miniZone)}>
                            <MeasurementsDragZone onZoneClick={handleImageClick} />
                        </div>
                        {imageList.map((preview, index) => (
                            <ImageCard
                                key={Math.random().toString(36)}
                                src={preview.previewUrl}
                                index={index}
                            />
                        ))}
                    </>
                ) : (
                    <MeasurementsDragZone />
                )}
            </div>
            {!!isImageOver && (
                <div
                    onDrop={handleDrop}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    className={classNames(cls.ActiveUploadArea)}
                >
                    <div className={cls.addImageTitle}>
                        {i18next.t('UploadImage.return.addImageTitle')}
                    </div>
                </div>
            )}
        </div>
    );
};
